import React from 'react';
import { useSiteData } from '../context/SiteDataContext';

const CategoryFooter = ({ categoryId = "oncology" }) => {
    const { siteData } = useSiteData();
    const footerData = siteData.categoryPages?.[categoryId]?.footerMinimal || {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
    };

    return (
        <footer className="bg-[#0f172a] text-white border-t-[3px] border-red-600">
            <div className="container mx-auto px-4 py-8">
                <div className="flex flex-col items-center justify-center space-y-4 text-center">
                    {/* Minimalist Logo & Brand */}
                    <div className="flex items-center justify-center space-x-3">
                        <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center shadow-lg">
                            <span className="text-white font-bold text-lg">M</span>
                        </div>
                        <span className="text-xl font-bold text-white tracking-tight">
                            {footerData.brandName}
                        </span>
                    </div>

                    {/* Copyright & Info */}
                    <div className="text-gray-400 text-[13px] font-medium max-w-2xl">
                        <span>© {footerData.copyrightYear} {footerData.brandName}. {footerData.licenseInfo}</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default CategoryFooter;
